module.exports = __webpack_public_path__ + "img/isamilo_lodge_gallery_11.9f0c7a34.jpeg";